import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);

const persistantStore = new VuexPersist({
  key: 'navigabilis',
  storage: window.localStorage
});

export default new Vuex.Store({
  state: {
    selectedArea: undefined,
    selectedAreaType: undefined,
    selectedSpot: undefined,
    availableSpots: undefined
  },
  plugins: [persistantStore.plugin],
  getters: {
    selectedArea: state => state.selectedArea,
    selectedAreaType: state => state.selectedAreaType,
    selectedSpot: state => state.selectedSpot,
    availableSpots: state => state.availableSpots
  },
  mutations: {
    area(state, payload) {
      state.selectedArea = payload;
    },
    areaType(state, payload) {
      state.selectedAreaType = payload;
    },
    spot(state, payload) {
      state.selectedSpot = payload;
    },
    availableSpots(state, payload) {
      state.availableSpots = payload;
    }
  }
});



// WEBPACK FOOTER //
// ./src/resources/store.js